import React from "react";
import { Flex } from "../../../Flex";
import moment from "moment/moment";
import { CommercialNonWorkingDaysDatePickerContainer } from "../../../CommercialNonWorkingDaysDatePicker/CommercialNonWorkingDaysDatePickerContainer";

interface Props {
  id: string;
  disconnectionDate: string;
}

export const DisconnectionDetailsDate: React.FC<Props> = ({
  id,
  disconnectionDate,
}) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.7}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      maxWidth={"422px"}
      mb={[4, 4, 4, 4]}
      mt={0}
    >
      <CommercialNonWorkingDaysDatePickerContainer
        id={`${id}-disconnection-date`}
        fieldId={"disconnectionDetails.disconnectionDate"}
        value={disconnectionDate}
        label={"Requested disconnection date"}
        displayDateFormat={"DD/MM/YYYY"}
        placeholder={"Select a date"}
        minDate={new Date()}
        maxDate={moment().add(3, "months").toDate()}
      />
    </Flex>
  );
};
